import { MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE } from 'constants/content'
import getValueOffPercent from 'lib/offer/getValueOffPercent'
import { useMemo } from 'react'

function useBedbankOfferSell(
  offer: App.BedbankOffer | App.BedbankOfferSummary,
  duration: number | undefined,
  rooms: Array<App.Occupants> | undefined,
): App.BedbankSellPriceInfo | null {
  return useMemo(() => {
    if (offer.sell?.price) {
      const numberRooms = rooms?.length || 1
      const los = duration || offer.sell.los
      const price = Math.round((offer.sell.price / offer.sell.los) * los * numberRooms)
      const value = Math.round((offer.sell.value / offer.sell.los) * los * numberRooms)
      const taxesAndFees = Math.round((offer.sell.taxesAndFees / offer.sell.los) * los * numberRooms)
      const propertyFees = Math.round((offer.sell.propertyFees / offer.sell.los) * los * numberRooms)
      const total = offer.sell.price + offer.sell.propertyFees
      const discountPercentage = getValueOffPercent(offer.sell.value, total)

      return {
        price,
        value,
        propertyFees,
        taxesAndFees,
        discountPercentage: discountPercentage >= MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE ? discountPercentage : 0,
        los,
      }
    }
    return null
  }, [offer, duration, rooms])
}

export default useBedbankOfferSell
